import React from "react";

import isIntuit from "Intuit/isIntuit";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import Button from "Common/Button";
import { CardSection } from "Common/Card";
import Header from "Cobalt/Header";
import Icon from "Common/Icon";

const ANALYTICS_LOCATION = "plan_details";

const handleSBCDownload = (plan) => {
  AnalyticsTracking.trackEvent("summary_of_benefits_viewed", {
    plan_id: plan.id,
    name: plan.raw_name,
    brand: plan.carrier,
    available: true,
    location: ANALYTICS_LOCATION,
    deprecatedName: "view-sbc",
    deprecatedLabel: null,
    deprecatedValue: plan.id,
  });
};

const handleSBCRequest = (plan) => {
  AnalyticsTracking.trackEvent("summary_of_benefits_viewed", {
    plan_id: plan.id,
    name: plan.raw_name,
    brand: plan.carrier,
    available: false,
    location: ANALYTICS_LOCATION,
    deprecatedName: "request-sbc",
    deprecatedLabel: null,
    deprecatedValue: plan.id,
  });
};

const renderSBCLinkCell = (plan) => {
  if (plan.has_sbc) {
    return (
      <Button color="link" p={0} target="_blank" className="sbc-download-link" href={plan.sbc_url} onClick={handleSBCDownload(plan)}>
        <Icon icon="download" style={{ marginRight: "4px" }} flavor="solid" />
        Summary of Benefits
      </Button>
    );
  }
  const body = `Hello SimplyInsured,\n\nPlease send me a copy of the Summary of Benefits and Coverage for the ${plan.carrier} ${plan.display_name} Plan.\n\nThank you!\n\n\nPlan ID: ${plan.id}\nPlan Name: ${plan.raw_name}`;
  const mailto_url = `mailto:hello+sbc@simplyinsured.com?subject=SBC Request &body=${encodeURIComponent(body)}`;
  return (
    <Button color="link" p={0} href={mailto_url} target="_top" className="sbc-download-link" onClick={handleSBCRequest(plan)}>
      Summary of Benefits and Coverage (SBC)
    </Button>
  );
};

const PlanDetailsDocuments = ({ plan }) => (
  <CardSection>
    <Header level={7} mb={3}>
      Plan Documents
    </Header>
    {renderSBCLinkCell(plan)}
  </CardSection>
);

export default PlanDetailsDocuments;
